import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Says why a control is disabled (QA-W7-2, QA-W7-3). A disabled button gets
 * no pointer or focus events, so the tooltip hangs on a focusable wrapper
 * that also carries the reason as its accessible description.
 * Without a reason, renders the children untouched.
 */
export function ReasonTooltip({ reason, children }: { reason: string; children: ReactNode }) {
  if (!reason) return <>{children}</>;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} className="inline-flex" data-disabled-reason={reason}>
            {children}
            <span className="sr-only">{reason}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent>{reason}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
